import Blockly from "blockly";
import Schema from "../schema";

import { menu as game__controls } from './game_controls';
import { menu as game__visuals } from './game_visuals';

export const menu = {
  name: (<div className="text"><u>G</u>ame</div>),
  trigger: 'g',
  children: {
    game__controls,
    game__visuals,
    'game_fortune_popup': {
      name: (<div className="text"><u>F</u>ortune Popup</div>),
      trigger: 'f',
    },
    'game_make_it_rain': {
      name: (<div className="text"><u>M</u>ake it Rain</div>),
      trigger: 'm',
    }
  }
}

/* ****************************************************************************************************************
 * Display a Fortune popup message.
 ******************************************************************************************************************/
Blockly.Blocks['game_fortune_popup'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_string');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['string'])
      .appendField('Display the following message as Fortune message')
      .connection
      .connect(shadow.outputConnection)

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Display an in-game message using the Fortune popup.');
  }
};

Blockly.JSON['game_fortune_popup'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['string'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_fortune_popup',
      params
    }
  } else return;
};

Schema.registerAction('game_fortune_popup', {
  "if": {
    "properties": {
      "action": {
        "const": "game_fortune_popup"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "string": {
            "type": "string",
          },
          "from_param": {
            "type": "string",
          }
        },
        "oneOf": [
          {
            "required": [
              "string"
            ]
          },
          {
            "required": [
              "from_param"
            ]
          }
        ],
        "additionalProperties": false
      },
    }
  }
})

/* ****************************************************************************************************************
 * Make it Rain
 ******************************************************************************************************************/
Blockly.Blocks['game_make_it_rain'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setMinimum(1);
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    let shadow2 = this.workspace.newBlock('input_number');
    shadow2.setMinimum(1);
    shadow2.setMaximum(120);
    shadow2.setShadow(true);
    shadow2.initSvg();
    shadow2.render();

    this.appendValueInput('Count')
      .setCheck(['number'])
      .appendField('Make it rain')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('pennies, over the coarse of')
    this.appendValueInput('Duration')
      .setCheck(['number'])
      .connection
      .connect(shadow2.outputConnection)
    this.appendDummyInput('trailing2')
      .appendField('seconds')

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Rains down pennies for the specified duration; will interact with Pog for Good Items and Specialist Dance for Good Items mods.');
  },
};

Blockly.JSON['game_make_it_rain'] = (block) => {
  let count = Blockly.JSON.valueToCode(block, 'Count', Blockly.JSON.ORDER_ATOMIC);
  let duration = Blockly.JSON.valueToCode(block, 'Duration', Blockly.JSON.ORDER_ATOMIC);
  let params = {};

  console.log(count, duration)

  if (count.hasOwnProperty('value')) {
    params['count'] = count['value'];
  } else {
    params['count'] = count
  }

  if (duration.hasOwnProperty('value')) {
    params['duration'] = duration['value'];
  } else {
    params['duration'] = duration
  }

  return {
    action: 'game_make_it_rain',
    params
  }
}

Schema.registerAction('game_make_it_rain', {
  "if": {
    "properties": {
      "action": {
        "const": "game_make_it_rain"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "count": {
            "oneOf": [
              {
                "type": "number",
              },
              {
                "type": "object",
                "properties": {
                  "from_param": {
                    "type": "string"
                  }
                }
              }
            ]
          },
          "duration": {
            "oneOf": [
              {
                "type": "number",
              },
              {
                "type": "object",
                "properties": {
                  "from_param": {
                    "type": "string"
                  }
                }
              }
            ]
          },
        },
        "required": [
          "count",
          "duration"
        ],
        "additionalProperties": false
      },
    }
  }
})

